import $ from 'jQuery';

import submitForm from './modules/submit-form';
import cookies from './modules/cookies';
import sentry from './modules/sentry';
import Header from './modules/header';
import GallerySlider from './modules/gallery-slider';
import Gallery from './modules/gallery';

import Formstyle from './modules/formstyle';

import 'styles/less/application';
import ScrollLink from './modules/scroll-link';

$(document).ready(() => {
  cookies.init();
  sentry.init();
  submitForm.init();
  Header.init();
  GallerySlider.init();
  Gallery.init();
  Formstyle.init();
  ScrollLink.init();
});



// WEBPACK FOOTER //
// ./src/static/js/main.js